// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html,\nbody {\n  height: 100%;\n}", "",{"version":3,"sources":["/home/mike/Documents/Projects/perso/trivia-fe/src/styles.scss","styles.scss"],"names":[],"mappings":"AAAA;;EAEE,YAAA;ACCF","file":"styles.scss","sourcesContent":["html,\nbody {\n  height: 100%;\n}\n","html,\nbody {\n  height: 100%;\n}"]}]);
// Exports
module.exports = exports;
